'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { useIsSSR } from '@hooks/useIsSSR';
import { classNames } from '@repo/ui/src/utils/classNames';
import styles from './styles.module.css';

type Type = 'inline' | 'summary';
interface Props {
  sku: string;
  enableSEO?: boolean;
  type?: Type;
  dark?: boolean;
}

const attributeMap: Record<Type, string> = {
  inline: 'inline_rating',
  summary: 'rating_summary',
};

const Rating = ({ sku, enableSEO = true, type = 'inline', dark = false }: Props) => {
  const { enableBazaarvoice } = useCurrentUrl();
  const isSSR = useIsSSR();
  return enableBazaarvoice ? (
    <div className={classNames('review-it ', dark && styles.dark)}>
      {!isSSR && (
        <span data-bv-show={attributeMap[type]} data-bv-product-id={sku} data-bv-seo={enableSEO} />
      )}
    </div>
  ) : null;
};

export default Rating;
